// import slider_1 from "../assets/Header1.jpg";
import slider_1 from "../assets/globe-nasa.jpg";
import slider_2 from "../assets/Header2.jpg";
import slider_3 from "../assets/Header3.jpg";

export const sliders = [
  {
    id: 1,
    image: slider_1,
    // alt: "First slide",
    caption:
      "Test Asia, South-East Division (ASE Division) is a division under United Nations Group of Experts on Geographical Names (UNGEGN), a UN-organization working for Standardization of geographical names (place-names).",
    interval: 3000,
  },
  {
    id: 2,
    image: slider_2,
    // alt: "Second slide",
    caption: null,
    interval: 3000,
  },
  {
    id: 3,
    image: slider_3,
    // alt: "Third slide",
    caption: null,
    interval: 3000,
  },
];

export default sliders;